/**
 * UsersTagInput
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Field } from 'redux-form';

// Form
import { RenderDropdown } from '../../forms';

// Selectors
import { selectOptions } from './selectors';

interface Props {
    options: {
        email: string
    }[];
    label?: string;
    name: string;
    placeholder?: string;
    validate?: Function | Function[];
    disabled?: boolean;
}

export class UsersTagInput extends React.PureComponent<Props> {
    render() {
        const {
            options,
            label,
            name,
            placeholder,
            validate,
            disabled
        } = this.props;

        return (
            <Field
                component={RenderDropdown}
                label={label}
                name={name}
                options={options}
                placeholder={placeholder}
                validate={validate}
                clearable={!disabled}
                fluid
                search
                selection
                multiple
                closeOnChange
                disabled={disabled}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector({
    options: selectOptions
});

export default connect(mapStateToProps)(UsersTagInput);
